import { GameCarousel } from './GameCarousel';
import { GameGrid } from './GameGrid';
import { Text } from './Text';

export const GameSet = ({ gameSet }) => {
  return (
    gameSet.games?.length > 0 && (
      <div className="w-full mx-auto mt-8 md:mt-12">
        <p className="px-8 md:px-10 mt-4 mb-2 md:mb-4 text-2xl md:text-3xl lg:text-4xl font-bold text-white capitalize">
          <Text translate>{gameSet.name}</Text>
        </p>
        {
          gameSet.type === "slider"
          ? <GameCarousel games={gameSet.games} />
          : <GameGrid games={gameSet.games} />
        }
        
      </div>
    )
  );
};
